import { observable, action } from "mobx"

class LzLayState {
  @observable
  isShow = false

  // zsyh:专属优惠留资、search:搜索留资
  @observable
  type = 'zsyh'

  @action.bound
  show(type) {
    let scrollTop = document.body.scrollTop || document.documentElement.scrollTop
    document.body.style.cssText += 'position:fixed;width:100%;left:0;top:-' + scrollTop + 'px;'
    
    this.isShow = true
    this.type = type
  }

  @action.bound
  hide() {
    let body = document.body
    body.style.position = 'static'
    let top = body.style.top
    document.body.scrollTop = document.documentElement.scrollTop = -parseInt(top,0)
    body.style.top = ''

    this.isShow = false
  }
}

export default new LzLayState()


// WEBPACK FOOTER //
// ./src/stores/LzLayState.js